import {
  BOOKING_RIDER_DETAILS_START,
  BOOKING_RIDER_DETAILS_SUCCESS,
  BOOKING_RIDER_DETAILS_ERROR,
  LIST_OF_MOTORCYCLE_START,
  LIST_OF_MOTORCYCLE_SUCCESS,
  LIST_OF_MOTORCYCLE_ERROR,
  VAS_BOOKING_LIST_START,
  VAS_BOOKING_LIST_SUCCESS,
  VAS_BOOKING_LIST_ERROR,
  RECOMMENDED_PRODUCT_START,
  RECOMMENDED_PRODUCT_SUCCESS,
  RECOMMENDED_PRODUCT_ERROR
} from "Constant/RentalCustomer";
const initialState = {
  loading: false,
  listMotorcycleLoading: false,
  data: [],
  motorCycleData: [],
  vasBooking: [],
  recommendedProductData: []
};

export default function customerReviewsReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case LIST_OF_MOTORCYCLE_START:
      return {
        ...state,
        listMotorcycleLoading: true,
      };
    case LIST_OF_MOTORCYCLE_SUCCESS:
      return {
        ...state,
        motorCycleData: action.payload,
        listMotorcycleLoading: false,
      };
    case LIST_OF_MOTORCYCLE_ERROR:
      return {
        ...state,
        listMotorcycleLoading: false,
        message: action.error.message,
      };
    case BOOKING_RIDER_DETAILS_START:
      return {
        ...state,
        loading: true,
      };
    case BOOKING_RIDER_DETAILS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case BOOKING_RIDER_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case VAS_BOOKING_LIST_START:
      return {
        ...state,
        loading: true,
      };
    case VAS_BOOKING_LIST_SUCCESS:
      return {
        ...state,
        vasBooking: action.payload,
        loading: false,
      };
    case VAS_BOOKING_LIST_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case RECOMMENDED_PRODUCT_START:
      return {
        ...state,
        loading: true,
      };
    case RECOMMENDED_PRODUCT_SUCCESS:
      return {
        ...state,
        recommendedProductData: action.payload,
        loading: false,
      };
    case RECOMMENDED_PRODUCT_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    default:
      return state;
  }
}
